// components/ConfirmModal.js
import React from 'react';
import './ConfirmModal.css'; // optional styling

const ConfirmModal = ({ open, message, onConfirm, onCancel }) => {
  if (!open) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <p>{message}</p>
        <div className="confirm-buttons">
          <button className="button blue" onClick={onConfirm}>Yes</button>
          <button className="button red" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
